import { render, staticRenderFns } from "./PapercleanConfigurazioneIvaListPage.vue?vue&type=template&id=f103f23e&scoped=true"
import script from "./PapercleanConfigurazioneIvaListPage.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneIvaListPage.vue?vue&type=script&lang=js"
import style0 from "./PapercleanConfigurazioneIvaListPage.vue?vue&type=style&index=0&id=f103f23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f103f23e",
  null
  
)

export default component.exports